import React, { Component } from 'react';
import { Link } from 'react-scroll';
import styled from 'styled-components';
import './style.css';
import logoAlt from '../../assets/logoAlt.svg';

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false
    };
  }

  handleClick = () => this.setState({ showMenu: !this.state.showMenu });
  render() {
    const { waypoint } = this.props;
    const offset = -50;

    return (
      <Nav active={this.state.showMenu}>
        <NavMobile active={this.state.showMenu}>
          <Link
            to="home"
            spy
            smooth
            duration={500}
            style={{ cursor: 'pointer', overflow: 'hidden' }}
            activeClass="active-nav"
            offset={offset}
            onClick={() => this.setState({ showMenu: false })}
          >
            <MobileItem active={this.state.showMenu} trans={0.25}>
              Home
            </MobileItem>
          </Link>
          <Link
            to="process"
            spy
            smooth
            duration={500}
            style={{ cursor: 'pointer', overflow: 'hidden' }}
            activeClass="active-nav"
            offset={offset}
            onClick={() => this.setState({ showMenu: false })}
          >
            <MobileItem active={this.state.showMenu} trans={0.5}>
              Product
            </MobileItem>
          </Link>
          <Link
            to="demo"
            spy
            smooth
            duration={500}
            style={{ cursor: 'pointer', overflow: 'hidden' }}
            activeClass="active-nav"
            offset={offset}
            onClick={() => this.setState({ showMenu: false })}
          >
            <MobileItem active={this.state.showMenu} trans={0.75}>
              Demo
            </MobileItem>
          </Link>
          <Link
            to="contact"
            spy
            smooth
            duration={500}
            style={{ cursor: 'pointer', overflow: 'hidden' }}
            activeClass="active-nav"
            offset={offset}
            onClick={() => this.setState({ showMenu: false })}
          >
            <MobileItem active={this.state.showMenu} trans={1}>
              Contact
            </MobileItem>
          </Link>
        </NavMobile>
        <div className="navbar-inner">
          <Link
            to="home"
            spy
            smooth
            duration={500}
            style={{
              height: '100%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Logo src={waypoint ? logoAlt : this.props.logo} />
          </Link>
          <ul className="main-nav">
            <Link
              to="process"
              spy
              smooth
              duration={500}
              style={{ height: '100%', cursor: 'pointer' }}
              activeClass="active-nav"
              offset={offset}
            >
              <li className="nav-item">Product</li>
            </Link>
            <Link
              to="demo"
              spy
              smooth
              duration={500}
              style={{ height: '100%', cursor: 'pointer' }}
              activeClass="active-nav"
              offset={offset}
            >
              <li className="nav-item">Demo</li>
            </Link>
            <Link
              to="contact"
              spy
              smooth
              duration={500}
              style={{ height: '100%', cursor: 'pointer' }}
              activeClass="active-nav"
              offset={offset}
            >
              <li className="nav-item">Contact</li>
            </Link>
          </ul>
          <ButtonWrapper onClick={this.handleClick}>
            <Button active={this.state.showMenu} />
          </ButtonWrapper>
        </div>
      </Nav>
    );
  }
}

export default Navigation;

const Nav = styled.div`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;
  top: 0;
  background: #262936;
  box-shadow: 0px -20px 90px #02adc3;
  background: #262936;
  @media (max-width: 950px) {
    ul {
      display: none;
    }
  }
`;

const Logo = styled.img`
  width: 125px;
  @media (max-width: 950px) {
    width: 90px;
  }
`;

const ButtonWrapper = styled.div`
  width: 50px;
  height: 30px;
  position: absolute;
  display: none;
  right: 1rem;
  cursor: pointer;
  @media (max-width: 950px) {
    display: block;
  }
`;

const Button = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 5px;
  background: #4babc0;
  background: #667db6; /* fallback for old browsers */
  background: linear-gradient(to right, #4babc0, #0082c8);
  border-radius: 5px;
  box-shadow: 0 10px 50px black;
  &:after {
    content: '';
    position: absolute;
    top: 10px;
    transition: 0.2s;
    right: ${props => (props.active ? '10px' : '0px')};
    width: ${props => (props.active ? '40px' : '45px')};
    height: 5px;
    background: #4babc0;
    background: #667db6; /* fallback for old browsers */
    background: linear-gradient(to right, #4babc0, #0082c8);
    border-radius: 5px;
    z-index: 2;
    box-shadow: 0 10px 50px black;
  }
  &:before {
    content: '';
    position: absolute;
    top: 20px;
    transition: 0.2s;
    right: ${props => (props.active ? '5px' : '0px')};
    width: ${props => (props.active ? '45px' : '40px')};
    height: 5px;
    background: #4babc0;
    background: #667db6; /* fallback for old browsers */
    background: linear-gradient(to right, #4babc0, #0082c8);
    border-radius: 5px;
    z-index: 2;
    box-shadow: 0 10px 50px black;
  }
`;

const NavMobile = styled.div`
  width: 100vw;
  height: calc(100vh - 50px);
  background: #262936;
  position: fixed;
  top: 50px;
  left: 0;
  transition: all 0.2s ease-in-out;
  transform: translatex(${props => (props.active ? '0' : '-100%')});
  opacity: ${props => (props.active ? '1' : '0')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const MobileItem = styled.div`
	width: 100%:
	height: 50px;
	font-size: 25px;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 10px 0;
	transition: 0.3s ${props => (props.active ? `${props.trans}s` : '0s')} ease-in-out;
	transform: translatex(${props => (props.active ? '0%' : '-100%')});
	opacity: ${props => (props.active ? '1' : '0')};
`;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js